import { LessonDef } from '../types';

// Lesson 21: 普通形＋と思います (expanded), ～でしょう？, ～かもしれません
export const lesson21: LessonDef = {
  id: 21,
  title: '第21课 大概…吧 / 也许…',
  titleJa: '～でしょう？ / ～かもしれません',
  difficulty: 'discrimination',
  grammarPoints: [
    {
      pattern: '普通形＋と思います（復習・拡張）',
      meaning: '表达自己的判断或意见（复习并扩展用法）',
      examples: [
        { ja: '来年、物価が上がると思います。', zh: '我认为明年物价会上涨。' },
        { ja: 'あの人は学生じゃないと思います。', zh: '我觉得那个人不是学生。' },
      ],
    },
    {
      pattern: '普通形＋でしょう？',
      meaning: '征求对方的同意或确认："……对吧？"',
      examples: [
        { ja: '明日は日曜日でしょう？', zh: '明天是星期天吧？' },
        { ja: 'この料理、おいしいでしょう？', zh: '这道菜好吃吧？' },
        { ja: '日本語の勉強は大変でしょう？', zh: '学日语很辛苦吧？' },
      ],
    },
    {
      pattern: '普通形＋かもしれません',
      meaning: '表示不确定的推测："也许/可能……"',
      examples: [
        { ja: '明日は雨が降るかもしれません。', zh: '明天也许会下雨。' },
        { ja: '彼は来ないかもしれません。', zh: '他也许不来。' },
        { ja: 'あの店は高いかもしれません。', zh: '那家店也许很贵。' },
      ],
    },
  ],
  vocab: [
    { ja: '多分', reading: 'たぶん', zh: '大概；也许', example: '多分大丈夫です' },
    { ja: 'きっと', reading: 'きっと', zh: '一定；肯定', example: 'きっとうまくいく' },
    { ja: '絶対', reading: 'ぜったい', zh: '绝对', example: '絶対に行きます' },
    { ja: '残念', reading: 'ざんねん', zh: '遗憾', example: '残念ですね' },
    { ja: '無理', reading: 'むり', zh: '不可能；勉强', example: '無理をしないでください' },
    { ja: '予定', reading: 'よてい', zh: '预定；计划', example: '明日の予定' },
    { ja: '天気予報', reading: 'てんきよほう', zh: '天气预报', example: '天気予報を見る' },
    { ja: '合格', reading: 'ごうかく', zh: '合格；及格', example: '試験に合格する' },
    { ja: '約束', reading: 'やくそく', zh: '约定', example: '約束を守る' },
    { ja: '遅刻', reading: 'ちこく', zh: '迟到', example: '遅刻しないでください' },
    { ja: '物価', reading: 'ぶっか', zh: '物价', example: '物価が上がる' },
    { ja: '間に合う', reading: 'まにあう', zh: '来得及', example: '電車に間に合う' },
    { ja: '大丈夫', reading: 'だいじょうぶ', zh: '没关系；不要紧', example: '大丈夫ですよ' },
    { ja: '心配', reading: 'しんぱい', zh: '担心', example: '心配しないでください' },
    { ja: '確か', reading: 'たしか', zh: '确实；好像是', example: '確か明日だったと思います' },
  ],
  vocabQuestions: [
    { type: 'vocab', prompt: '多分', promptAudio: 'たぶん', choices: ['大概', '绝对', '完全', '非常'], correctIndex: 0 },
    { type: 'vocab', prompt: 'きっと', promptAudio: 'きっと', choices: ['偶然', '一定', '刚刚', '突然'], correctIndex: 1 },
    { type: 'vocab', prompt: '絶対', promptAudio: 'ぜったい', choices: ['相对', '大致', '绝对', '大约'], correctIndex: 2 },
    { type: 'vocab', prompt: '残念', promptAudio: 'ざんねん', choices: ['开心', '无聊', '意外', '遗憾'], correctIndex: 3 },
    { type: 'vocab', prompt: '無理', promptAudio: 'むり', choices: ['不可能', '可能', '简单', '方便'], correctIndex: 0 },
    { type: 'vocab', prompt: '予定', promptAudio: 'よてい', choices: ['记忆', '预定', '提议', '感想'], correctIndex: 1 },
    { type: 'vocab', prompt: '天気予報', promptAudio: 'てんきよほう', choices: ['新闻', '报纸', '天气预报', '交通信息'], correctIndex: 2 },
    { type: 'vocab', prompt: '合格', promptAudio: 'ごうかく', choices: ['失败', '退学', '毕业', '合格'], correctIndex: 3 },
    { type: 'vocab', prompt: '約束', promptAudio: 'やくそく', choices: ['约定', '规则', '法律', '习惯'], correctIndex: 0 },
    { type: 'vocab', prompt: '遅刻', promptAudio: 'ちこく', choices: ['早退', '迟到', '缺席', '出席'], correctIndex: 1 },
    { type: 'vocab', prompt: '物価', promptAudio: 'ぶっか', choices: ['价格', '价值', '物价', '费用'], correctIndex: 2 },
    { type: 'vocab', prompt: '間に合う', promptAudio: 'まにあう', choices: ['来不及', '不合适', '不够', '来得及'], correctIndex: 3 },
    { type: 'vocab', prompt: '大丈夫', promptAudio: 'だいじょうぶ', choices: ['没关系', '不行', '危险', '不好'], correctIndex: 0 },
    { type: 'vocab', prompt: '心配', promptAudio: 'しんぱい', choices: ['放心', '担心', '安心', '开心'], correctIndex: 1 },
    { type: 'vocab', prompt: '確か', promptAudio: 'たしか', choices: ['不确定', '大概', '确实', '随便'], correctIndex: 2 },
    { type: 'vocab', prompt: '約束', promptAudio: 'やくそく', choices: ['命令', '规定', '条件', '约定'], correctIndex: 3 },
  ],
  assemblyQuestions: [
    {
      type: 'assembly',
      meaning: '明天也许会下雨。',
      blocks: ['降る', '雨が', 'かもしれません', '明日は'],
      correctOrder: ['明日は', '雨が', '降る', 'かもしれません'],
    },
    {
      type: 'assembly',
      meaning: '这道菜好吃吧？',
      blocks: ['でしょう？', 'おいしい', 'この料理'],
      correctOrder: ['この料理', 'おいしい', 'でしょう？'],
      hint: '征求同意用「でしょう？」',
    },
    {
      type: 'assembly',
      meaning: '他也许不来。',
      blocks: ['かもしれません', '彼は', '来ない'],
      correctOrder: ['彼は', '来ない', 'かもしれません'],
    },
    {
      type: 'assembly',
      meaning: '学日语很辛苦吧？',
      blocks: ['大変', 'の勉強は', 'でしょう？', '日本語'],
      correctOrder: ['日本語', 'の勉強は', '大変', 'でしょう？'],
    },
    {
      type: 'assembly',
      meaning: '我认为明年物价会上涨。',
      blocks: ['上がる', '物価が', 'と', '来年', '思います'],
      correctOrder: ['来年', '物価が', '上がる', 'と', '思います'],
    },
    {
      type: 'assembly',
      meaning: '也许来得及赶上电车。',
      blocks: ['かもしれません', '間に合う', '電車に'],
      correctOrder: ['電車に', '間に合う', 'かもしれません'],
    },
    {
      type: 'assembly',
      meaning: '大概能考试合格吧。',
      blocks: ['でしょう', '合格する', '多分', '試験に'],
      correctOrder: ['多分', '試験に', '合格する', 'でしょう'],
    },
    {
      type: 'assembly',
      meaning: '也许那家店已经关了。',
      blocks: ['もう', 'あの店は', '閉まった', 'かもしれません'],
      correctOrder: ['あの店は', 'もう', '閉まった', 'かもしれません'],
    },
    {
      type: 'assembly',
      meaning: '明天是星期天吧？',
      blocks: ['日曜日', 'でしょう？', '明日は'],
      correctOrder: ['明日は', '日曜日', 'でしょう？'],
    },
    {
      type: 'assembly',
      meaning: '今天的会议也许会取消。',
      blocks: ['中止になる', 'かもしれません', '会議は', '今日の'],
      correctOrder: ['今日の', '会議は', '中止になる', 'かもしれません'],
    },
    {
      type: 'assembly',
      meaning: '我觉得他不会迟到。',
      blocks: ['遅刻しない', '彼は', 'と', '思います'],
      correctOrder: ['彼は', '遅刻しない', 'と', '思います'],
    },
  ],
  grammarCheckQuestions: [
    {
      type: 'grammar_check',
      prompt: '哪句正确表达了"明天也许会下雨"？',
      sentences: [
        '明日は雨が降るかもしれません。',
        '明日は雨が降りますかもしれません。',
        '明日は雨が降るかもしれます。',
      ],
      correctIndex: 0,
      explanation: '「かもしれません」前面接普通形。「降ります」是丁宁形，应改为「降る」。「かもしれません」本身不能变形。',
    },
    {
      type: 'grammar_check',
      prompt: '哪句正确使用了「～でしょう？」征求同意？',
      sentences: [
        'この料理はおいしいでしょう？',
        'この料理はおいしいですでしょう？',
        'この料理はおいしでしょう？',
      ],
      correctIndex: 0,
      explanation: 'い形容词直接接「でしょう？」。不需要加「です」，也不能省略「い」。',
    },
    {
      type: 'grammar_check',
      prompt: '哪句正确表达了"他也许不会来"？',
      sentences: [
        '彼は来ないかもしれません。',
        '彼は来ませんかもしれません。',
        '彼は来るないかもしれません。',
      ],
      correctIndex: 0,
      explanation: '动词否定普通形「来ない」＋「かもしれません」。丁宁形「来ません」不能接「かもしれません」。',
    },
    {
      type: 'grammar_check',
      prompt: '哪句的语法有错误？',
      sentences: [
        '多分、合格するでしょう。',
        '確か、明日は休みだったと思います。',
        '彼女は学生だかもしれません。',
      ],
      correctIndex: 2,
      explanation: '名词/な形容词接「かもしれません」时，不加「だ」。应该说「学生かもしれません」。',
    },
    {
      type: 'grammar_check',
      prompt: '"明天是星期天吧？"哪个说法正确？',
      sentences: [
        '明日は日曜日だでしょう？',
        '明日は日曜日でしょう？',
        '明日は日曜日ですでしょう？',
      ],
      correctIndex: 1,
      explanation: '名词接「でしょう？」时，不加「だ」也不加「です」。直接「名词＋でしょう？」。',
    },
    {
      type: 'grammar_check',
      prompt: '哪句正确表达了"也许来不及"？',
      sentences: [
        '間に合わないかもしれません。',
        '間に合いませんかもしれません。',
        '間に合わないかもしれないです。',
      ],
      correctIndex: 0,
      explanation: '「間に合わない」是否定普通形，后接「かもしれません」。丁宁形不能接「かもしれません」。',
    },
    {
      type: 'grammar_check',
      prompt: '以下哪句使用了正确的确定程度？',
      sentences: [
        '多分、雨が降るでしょう。',
        '絶対、雨が降るかもしれません。',
        'きっと、雨が降るかもしれません。',
      ],
      correctIndex: 0,
      explanation: '「多分」配「でしょう」表示推测。「絶対/きっと」表示确信，不应该和表示不确定的「かもしれません」一起用。',
    },
    {
      type: 'grammar_check',
      prompt: '哪句正确表达了"那家餐厅的菜也许很贵"？',
      sentences: [
        'あのレストランの料理は高いかもしれません。',
        'あのレストランの料理は高いですかもしれません。',
        'あのレストランの料理は高くかもしれません。',
      ],
      correctIndex: 0,
      explanation: 'い形容词的普通形直接接「かもしれません」。「高い」＋「かもしれません」。',
    },
    {
      type: 'grammar_check',
      prompt: '"学日语很有意思吧？"正确的说法是？',
      sentences: [
        '日本語の勉強はおもしろいでしょう？',
        '日本語の勉強はおもしろですでしょう？',
        '日本語の勉強はおもしろいだでしょう？',
      ],
      correctIndex: 0,
      explanation: 'い形容词直接接「でしょう？」，不需要加「です」或「だ」。',
    },
  ],
  dialogueQuestions: [
    {
      type: 'dialogue',
      context: '看天气预报后和同事聊天。',
      lines: [
        { speaker: '同事A', text: '明日の天気、知ってますか。' },
        { speaker: '同事B', text: '天気予報によると、___', isBlank: true },
      ],
      choices: [
        '雨が降りますかもしれません。',
        '雨が降るかもしれません。',
        '雨が降るかもしれないです。',
      ],
      correctIndex: 1,
    },
    {
      type: 'dialogue',
      context: '一起去了新开的餐厅。',
      lines: [
        { speaker: 'A', text: 'この店の料理、おいしいでしょう？' },
        { speaker: 'B', text: '___', isBlank: true },
      ],
      choices: [
        'ええ、本当においしいですね。',
        'ええ、おいしいかもしれません。',
        'ええ、おいしいでしょう。',
      ],
      correctIndex: 0,
    },
    {
      type: 'dialogue',
      context: '担心朋友的考试结果。',
      lines: [
        { speaker: 'A', text: '田中さん、試験に合格できるかな。' },
        { speaker: 'B', text: '___', isBlank: true },
        { speaker: 'A', text: 'そうだといいですね。' },
      ],
      choices: [
        '多分、大丈夫だと思いますよ。',
        '多分、大丈夫ですと思います。',
        '多分、大丈夫かもしれます。',
      ],
      correctIndex: 0,
    },
    {
      type: 'dialogue',
      context: '约好了时间，朋友还没到。',
      lines: [
        { speaker: 'A', text: '山田さん、まだ来ませんね。' },
        { speaker: 'B', text: '___', isBlank: true },
      ],
      choices: [
        '遅刻するかもしれませんね。',
        '遅刻しますかもしれませんね。',
        '遅刻するかもしれますね。',
      ],
      correctIndex: 0,
    },
    {
      type: 'dialogue',
      context: '朋友推荐了一家店。',
      lines: [
        { speaker: 'A', text: '駅の近くに新しいラーメン屋ができたよ。' },
        { speaker: 'B', text: 'へえ。___', isBlank: true },
        { speaker: 'A', text: 'いや、そんなに高くないと思うよ。' },
      ],
      choices: [
        '高いでしょう？',
        '高いかもしれません。',
        '高いですかもしれません。',
      ],
      correctIndex: 1,
    },
    {
      type: 'dialogue',
      context: '讨论公司的未来。',
      lines: [
        { speaker: '社员A', text: '来年、会社はどうなると思いますか。' },
        { speaker: '社员B', text: '___', isBlank: true },
      ],
      choices: [
        'もっと忙しくなるかもしれませんね。',
        'もっと忙しくなりますかもしれません。',
        'もっと忙しいになるかもしれません。',
      ],
      correctIndex: 0,
    },
    {
      type: 'dialogue',
      context: '同学到了日本后的感受。',
      lines: [
        { speaker: 'A', text: '日本の生活はどうですか。' },
        { speaker: 'B', text: '楽しいですが、___', isBlank: true },
      ],
      choices: [
        '日本語がもっと上手になりたいでしょう。',
        '日本語はまだまだだと思います。',
        '日本語はまだまだですと思います。',
      ],
      correctIndex: 1,
    },
  ],
};
